/* increase z-index to be stacked above office ui fabric containers. */

$arrowWidth: 15px;
$arrowHeight: 15px;

.tooltip {
  z-index: 1000000 !important;
  pointer-events: none;
}

.tooltip[x-out-of-boundaries] {
  display: none;
}

td.global-tooltip-trigger,
div.global-tooltip-trigger,
span.global-tooltip-trigger {
  cursor: default;
}

.global-tooltip td span.global-tooltip-trigger {
  min-width: 20px;
  display: inline-block;
}

.global-tooltip {
  &.tooltip,
  &.show {
    opacity: 1;
  }

  .tooltip-inner {
    max-width: 350px;
    text-align: left;
    background: var(--bs-tooltip-bg);
    color: var(--bs-tooltip-color);
    font-size: 14px !important;
    text-align: left;
    pointer-events: auto !important;
    max-width: 450px;
    border: 1px solid var(--bs-tooltip-bg) !important;
    box-shadow: 0 4px rgba(180, 180, 180, 0.5);
    white-space: break-spaces;
    word-break: break-word;
    overflow: visible;

    code {
      color: #fff;
    }

    em {
      color: orange;
      background: transparent;
    }

    .ms-Table {
      margin: 0;
      padding: 0;
    }

    tr {
      line-height: 20px;
    }

    p {
      margin-bottom: 0.5rem;
    }

    ul,
    ol {
      white-space: normal;
      margin: 0 0 0.5rem 1.5rem;
      padding: 0;

      li {
        line-height: unset;
        padding: 0;
      }
    }
  }

  .tooltip-arrow {
    display: block;

    &::before {
      border-width: 7px;
    }
  }

  &.bs-tooltip-auto[data-popper-placement^='right'] .tooltip-arrow::before,
  &.bs-tooltip-right .tooltip-arrow::before {
    border-right-color: var(--bs-tooltip-bg);
    width: $arrowWidth;
    height: $arrowHeight;
  }

  &.bs-tooltip-auto[data-popper-placement^='bottom'] .tooltip-arrow::before,
  &.bs-tooltip-bottom .tooltip-arrow::before {
    border-bottom-color: var(--bs-tooltip-bg);
    width: $arrowWidth;
    height: $arrowHeight;
  }

  &.bs-tooltip-auto[data-popper-placement^='left'] .tooltip-arrow::before,
  &.bs-tooltip-left .tooltip-arrow::before {
    border-left-color: var(--bs-tooltip-bg);
    width: $arrowWidth;
    height: $arrowHeight;
  }

  &.bs-tooltip-auto[data-popper-placement^='top'] .tooltip-arrow::before,
  &.bs-tooltip-top .tooltip-arrow::before {
    border-top-color: var(--bs-tooltip-bg);
    width: $arrowWidth;
    height: $arrowHeight;
  }
}
